import Game from "./Game";

export default class BGMan {
  timeOffset: number;
  dayCycleDuration: number;
  DayColor: number;
  NightColor: number;
  RunTimeHue: boolean;
  canScroll: boolean;
  scene: Phaser.Scene;
  bgtile: Phaser.GameObjects.TileSprite;
  private targetTileX: number = 0;
  private targetTileY: number = 0;
  private scrollSpeed: number = 1; // Interpolation factor (0-1, higher = faster)

  constructor(scene: Phaser.Scene) {
    this.timeOffset = 0;
    this.dayCycleDuration = 900;
    this.DayColor = 0xffffff;
    this.NightColor = 279790;
    this.RunTimeHue = true;
    this.canScroll = true;
    this.scene = scene;
  }

  MakeBackground(texture: string = "bgTile") {
    this.bgtile = this.scene.add.tileSprite(
      0.25 * this.scene.renderer.width,
      0.25 * this.scene.renderer.height,
      this.scene.renderer.width,
      this.scene.renderer.height,
      texture
    );
    this.bgtile
      .setScrollFactor(0)
      .setDepth(Number.NEGATIVE_INFINITY)
      .setScale(4);

    // Initialize tile positions
    this.targetTileX = Game.Core.Player.x / 4;
    this.targetTileY = Game.Core.Player.y / 4;
    this.bgtile.tilePositionX = this.targetTileX;
    this.bgtile.tilePositionY = this.targetTileY;
  }

  Update(delta: number = 0) {
    if (this.canScroll && this.bgtile) {
      // Calculate target positions based on player position
      this.targetTileX = Game.Core.Player.x / 4;
      this.targetTileY = Game.Core.Player.y / 4;

      // Delta-aware interpolation for smooth scrolling
      const deltaTime = delta / 1000; // Convert to seconds
      const lerpFactor = Math.min(1, this.scrollSpeed * deltaTime * 60); // Normalize to 60fps

      // Smoothly interpolate to target positions
      this.bgtile.tilePositionX = Phaser.Math.Linear(
        this.bgtile.tilePositionX,
        this.targetTileX,
        lerpFactor
      );
      this.bgtile.tilePositionY = Phaser.Math.Linear(
        this.bgtile.tilePositionY,
        this.targetTileY,
        lerpFactor
      );
    }
  }

  ToggleScrolling(canScroll: boolean) {
    this.canScroll = canScroll;
  }
}
